import { useState as s, useEffect as c } from "react";
const r = "(prefers-reduced-motion: reduce)", a = () => window.matchMedia(r).matches, i = () => {
  const [o, t] = s(!1);
  return c(() => {
    const e = window.matchMedia(r);
    t(e.matches);
    const n = () => {
      t(e.matches);
    };
    return e.addEventListener("change", n), () => e.removeEventListener("change", n);
  }, []), o;
};
export {
  a as getPrefersReducedMotion,
  i as usePrefersReducedMotion
};
